import * as React from "react";

import {HaccpController} from "../../HaccpController";
import "./ConfirmationPopup.scss";
import {VeBoxModal} from "../../../../../components/modal/VeBoxModal";

export interface ConfirmationPopupProps {
    texts: {
        title: string,
        content: string,
        cancel: string,
        confirm: string,
    };
    onCancel: () => void;
    onConfirm: () => void;
    haccpController: HaccpController;
    equipmentGuid: string;
}

export const ConfirmationPopup: React.FunctionComponent<ConfirmationPopupProps> = (props: ConfirmationPopupProps) => {
    return (
        <VeBoxModal style={{width: 350}}>
            <VeBoxModal.Header title={props.texts.title}/>
            <VeBoxModal.Section>
                <p>{props.texts.content}</p>
            </VeBoxModal.Section>
            <VeBoxModal.StandardActions
                onSubmit={props.onConfirm}
                onCancel={props.onCancel}
            />
        </VeBoxModal>
    );
};
